module.exports = __webpack_public_path__ + "img/back.26360622.png";